import axios from 'axios';
import { limpiaLocalStorage } from '../../project/utils/utils';
//
// #############################################################################
//
axios.interceptors.request.use(
  (request) => {

    const _token = localStorage.getItem("token");

    if (_token) {
      request.headers.Authorization = `Bearer ${_token}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//
// #############################################################################
//
axios.interceptors.response.use(
  (response) => {

    const _response = response.data || {};

    if ("code" in _response) {

      const _errorCode = _response.code;

      if (["err-token-expired", "err-token-invalid"].includes(_errorCode)) {

        console.warn('Token invalido o expirado:', _errorCode, _response.description || '');
        limpiaLocalStorage();

        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }

        return Promise.reject(new Error('Error de autenticación: token expirado'));
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
